import React, { useEffect } from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setBreadcrumbList } from '../../store/menuInfo/menuInfo';
import './index.scss';

const NotFound = (props) => {
  const { title } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setBreadcrumbList([{ title: title }]));
  }, [dispatch]);

  return (
    <div className="notFoundContainer">
        <Result
        status="404"
        title="404"
        subTitle="抱歉，您访问的页面不存在。"
        extra={<Button type="primary" onClick={() => navigate('/')}>返回首页</Button>}
        />
    </div>
  );
};

export default NotFound;
